import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const SedeSelect = ({ value, onChange, testid }) => {
  const [sedi, setSedi] = useState([]);
  useEffect(() => { api.get("/sedi").then((r) => setSedi(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-1.5">
      <Label>Sede appuntamento</Label>
      <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)}>
        <SelectTrigger data-testid={testid}><SelectValue placeholder="Seleziona sede" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Nessuna sede</SelectItem>
          {sedi.map((s) => <SelectItem key={s.id} value={s.id}>{s.nome}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
};
